<template>
  <div>
    <header class="hidden-sm-up">
      <nav class="navbar navbar-md navbar-fixed-top primary text-white">
        <div class="container">
          <!-- <a data-toggle="collapse" data-target="#navbar-1" class="navbar-item pull-right hidden-md-up m-a-0 m-l">
            <i class="fa fa-bars"></i>
          </a>-->
          <!-- brand -->
          <a class="navbar-brand lg" href="#home" ui-scroll-to="home">
            <img src="http://images.eurcd.com/web/index/logo.png" />
          </a>
          <!-- / brand -->
          <!-- nabar right -->
          <ul class="nav navbar-nav pull-right">
            <li class="nav-item">
              <!-- <a class="nav-link" href="https://mini.eurcd.com" target="_blank">
                <span class="btn btn-sm rounded primary text-u-c _700">登录商户平台</span>
              </a>-->
              <a class="nav-link" href="javascript:void(0)" @click.prevent="openModal()">
                <span class="btn btn-sm rounded primary text-u-c _700">登录商户平台</span>
              </a>
            </li>
          </ul>
          <!-- / navbar right -->
        </div>
      </nav>
    </header>
    <header class="hidden-xs-down">
      <nav :class="headerStyle">
        <div class="container">
          <!-- <a data-toggle="collapse" data-target="#navbar-1" class="navbar-item pull-right hidden-md-up m-a-0 m-l">
            <i class="fa fa-bars"></i>
          </a>-->

          <!-- brand -->
          <a class="navbar-brand lg" href="#home" ui-scroll-to="home">
            <img src="http://images.eurcd.com/web/index/logo.png" />
          </a>
          <!-- / brand -->
          <!-- nabar right -->
          <ul class="nav navbar-nav pull-right">
            <li class="nav-item">
              <!-- <a class="nav-link" href="https://mini.eurcd.com" target="_blank">
                <span class="btn btn-sm rounded primary text-u-c _700">登录商户平台</span>
              </a>-->
              <a class="nav-link" href="javascript:void(0)" @click.prevent="openModal()">
                <span class="btn btn-sm rounded primary text-u-c _700">登录商户平台</span>
              </a>
            </li>
          </ul>
          <!-- / navbar right -->
          <!-- navbar collapse -->
          <div class="collapse navbar-toggleable-sm text-center white" id="navbar-1">
            <!-- link and dropdown -->
            <ul class="nav navbar-nav nav-active-border top b-primary pull-right m-r-lg">
              <li class="nav-item">
                <a class="nav-link" href="#solution">
                  <span class="nav-text">解决方案</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#join">
                  <span class="nav-text">招商加盟</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about">
                  <span class="nav-text">关于欧城记</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact">
                  <span class="nav-text">联系我们</span>
                </a>
              </li>
            </ul>
            <!-- / link and dropdown -->
          </div>
          <!-- / navbar collapse -->
        </div>
      </nav>
    </header>
  </div>
</template>
<script>
export default {
  props: {
    headerStyle: {
      type: String,
      default: 'navbar navbar-md navbar-fixed-top no-bg text-white'
    }
  },
  methods: {
    openModal() {
      this.$emit('open-modal')
    }
  },
  data() {
    return {
      title: ''
    }
  },
  mounted() {
    this.title = this.GLOBAL.title
  }
}
</script>
<style scoped>
</style>


